import Vue from 'vue'
import store from '@/store/'
import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  ACCOUNT_TYPE,
  DEFAULT_CONTENT_WIDTH_TYPE
} from '@/store/mutation-types'
import config from '@/config/defaultSettings'

export default function Initializer() {
  console.log(`API_URL: ${process.env.VUE_APP_API_BASE_URL}`)

  store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
  store.commit('SET_TYPE', Vue.ls.get(ACCOUNT_TYPE))
  store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
  store.commit(
    'TOGGLE_CONTENT_WIDTH',
    Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth)
  )

  // last step
}
